// ResetPasswordViewModel.js
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMounted } from 'src/hooks/use-mounted';
import { startLoading, stopLoading } from 'src/utils/loading';
import { resetPassword } from './my-model';

const initialValues = {
  user: '',
  email: '',
  submit: null,
};

const validationSchema = Yup.object({
  user: Yup.string().required('Username đang trống'),
  email: Yup.string()
    .required('Email đang trống')
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Sai định dạng',
    ),
});

const useViewModel = (onApiSuccess) => {
  const isMounted = useMounted();

  const onSubmit = async (formData, helpers) => {
    startLoading();
    const { result, error } = await resetPassword(formData);
    if (isMounted()) {
      if (result) {
        const msg = result.result || 'Password had sent to email';
        onApiSuccess(msg);
      } else if (error) {
        const msg = error.message || 'Account or Email incorrect';
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: msg });
        helpers.setSubmitting(false);
      }
    }
    stopLoading();
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false, // Disable validation on change
    validateOnBlur: false, // Disable validation on blur
    onSubmit,
  });

  return {
    formik,
  };
};

export default useViewModel;
